export const editorFontStyle = {
  fontFamily: 'var(--console-font-mono, ui-monospace, monospace)',
  fontSize: 'var(--console-text-code, 13px)',
  lineHeight: 'var(--console-line-code, 20px)',
  tabSize: 2,
  whiteSpace: 'pre' as const,
}
